module.exports = __webpack_public_path__ + "media/images/partners/barefoot-4846e9a362893eeb79ba052e74a0e7de.svg";